var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comp-form',{ref:"comp_form",attrs:{"title":"创建畅联组","forms":_vm.structure,"id-key":"appId","height":"auto","width":"450px"},on:{"on-submit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }